import { CheckNotes, InspectionCase } from '../inspection-cases';

export class GasIndoorTestDto extends InspectionCase {
  shutdownTriggeredByOneDetector?: InspectionCase;
  crossChecked?: InspectionCase;
  beforeShutdownDelay?: InspectionCase;
  shutdownLampExist?: InspectionCase;
  evacuationHornExist?: InspectionCase;
  evacuationHornWorksAsExpected?: InspectionCase;
  ventilationSystemWorksAsExpected?: InspectionCase;
  yellowShutdownButtonInstalled?: InspectionCase;
  extinguishingSpaceIncludesDoors?: InspectionCase;
  engSystemInstallationAccordingToPcOutput?: InspectionCase;
  fireAndPlumbingTanksSetAccordingToRequirements?: InspectionCase;
  nostrilsDistanceAccordingToRequirements?: InspectionCase;
}

export class GasIndoorTest extends GasIndoorTestDto {
  constructor(data: GasIndoorTestDto = { title: 'בדיקת כיבוי בחלל' }) {
    super(data);
    this.shutdownTriggeredByOneDetector = new InspectionCase({
      ...data.shutdownTriggeredByOneDetector,
      title: `הכיבוי הופעל ע"י גלאי אחד`
    });
    this.crossChecked = new InspectionCase({
      ...data.crossChecked,
      title: `הפעלת הכיבוי בוצע בהצלבה`
    });
    this.beforeShutdownDelay = new InspectionCase({
      ...data.beforeShutdownDelay,
      title: `קיימת השהייה של 20-30 שניות לפני הכיבוי. זמן השהייה נמדד:`
    });
    this.shutdownLampExist = new InspectionCase({
      ...data.shutdownLampExist,
      title: `הותקן מנורה "הופעל כיבוי " מחוץ לחלל.`
    });
    this.evacuationHornExist = new InspectionCase({
      ...data.evacuationHornExist,
      title: `הותקן צופר פינוי בתוך החלל המוגן כפי שנדרש בסעיף 5.3.5.5 ב-NFPA`
    });
    this.evacuationHornWorksAsExpected = new InspectionCase({
      ...data.evacuationHornWorksAsExpected,
      title: `צופר הפינוי מבוקר כנגד נתק וממשיך לפעול עד לאיפוס המערכת`
    });
    this.ventilationSystemWorksAsExpected = new InspectionCase({
      ...data.ventilationSystemWorksAsExpected,
      title: `מערכת האוורור נותקה לפני הפעלת המערכת`
    });
    this.yellowShutdownButtonInstalled = new InspectionCase({
      ...data.yellowShutdownButtonInstalled,
      title: `הותקן לחצן כיבוי צהוב וקיים ידית הפעלה מכנית על גבי המיכל`
    });
    this.extinguishingSpaceIncludesDoors = new InspectionCase({
      ...data.extinguishingSpaceIncludesDoors,
      title: `חלל הכיבוי אטום. כולל: מחזיר דלת , פתחים חלונות ודלתות.`
    });
    this.engSystemInstallationAccordingToPcOutput = new InspectionCase({
      ...data.engSystemInstallationAccordingToPcOutput,
      title: `במערכת ה Eng ההתקנה בוצעה בהתאם לפלט הרצת המחשב`
    });
    this.fireAndPlumbingTanksSetAccordingToRequirements = new InspectionCase({
      ...data.fireAndPlumbingTanksSetAccordingToRequirements,
      title: `מכלי הכיבוי והצנרת מחוזקים בהתאם לדרישות היצרן`
    });
    this.nostrilsDistanceAccordingToRequirements = new InspectionCase({
      ...data.nostrilsDistanceAccordingToRequirements,
      title: `המרחק בין הנחירים תואם את הוראות היצרן`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.shutdownTriggeredByOneDetector.isApplicable ||
        this.shutdownTriggeredByOneDetector.isPassed) &&
        (!this.crossChecked.isApplicable || this.crossChecked.isPassed) &&
        (!this.beforeShutdownDelay.isApplicable ||
          this.beforeShutdownDelay.isPassed) &&
        (!this.shutdownLampExist.isApplicable ||
          this.shutdownLampExist.isPassed) &&
        (!this.evacuationHornExist.isApplicable ||
          this.evacuationHornExist.isPassed) &&
        (!this.evacuationHornWorksAsExpected.isApplicable ||
          this.evacuationHornWorksAsExpected.isPassed) &&
        (!this.ventilationSystemWorksAsExpected.isApplicable ||
          this.ventilationSystemWorksAsExpected.isPassed) &&
        (!this.yellowShutdownButtonInstalled.isApplicable ||
          this.yellowShutdownButtonInstalled.isPassed) &&
        (!this.extinguishingSpaceIncludesDoors.isApplicable ||
          this.extinguishingSpaceIncludesDoors.isPassed) &&
        (!this.engSystemInstallationAccordingToPcOutput.isApplicable ||
          this.engSystemInstallationAccordingToPcOutput.isPassed) &&
        (!this.fireAndPlumbingTanksSetAccordingToRequirements.isApplicable ||
          this.fireAndPlumbingTanksSetAccordingToRequirements.isPassed) &&
        (!this.nostrilsDistanceAccordingToRequirements.isApplicable ||
          this.nostrilsDistanceAccordingToRequirements.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.shutdownTriggeredByOneDetector.getNotes(),
      ...this.crossChecked.getNotes(),
      ...this.beforeShutdownDelay.getNotes(),
      ...this.shutdownLampExist.getNotes(),
      ...this.evacuationHornExist.getNotes(),
      ...this.evacuationHornWorksAsExpected.getNotes(),
      ...this.ventilationSystemWorksAsExpected.getNotes(),
      ...this.yellowShutdownButtonInstalled.getNotes(),
      ...this.extinguishingSpaceIncludesDoors.getNotes(),
      ...this.engSystemInstallationAccordingToPcOutput.getNotes(),
      ...this.fireAndPlumbingTanksSetAccordingToRequirements.getNotes(),
      ...this.nostrilsDistanceAccordingToRequirements.getNotes()
    ];
  }
}
